import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation, makeStateKey } from '@angular/core';


import { HomeCarouselComponent } from './home-carousel/home-carousel.component';
import { HomeCarousel2Component } from './home-carousel2/home-carousel2.component';
import { BrandsWeDoComponent } from './brands-we-do/brands-we-do.component';
import { Category, Item, ItemService } from '../item-detail/item-detail.service';
import { ProductGridComponent } from './product-grid/product-grid.component';
import { ProductGrid1Component } from '../grids/product-grid1/product-grid1.component';
import { Meta, Title } from '@angular/platform-browser';
import { HomeContactUsComponent } from './contact-us/contact-us.component';
import { WarrentyServiceAndETCComponent } from './warrenty-service-and-etc/warrenty-service-and-etc.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { PrerenderDataService } from '../../prerender-data.service';
import { BehaviorSubject, Observable, Subject, concatMap, forkJoin, map, mergeMap, reduce, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppMessageService } from '../../app.message.service';
import { VideosComponent } from '../youtubeVideos/videos/videos.component';
import { ShortsComponent } from '../youtubeVideos/shorts/shorts.component';
import { ProdCardComponent } from '../grids/prod-card/prod-card.component';
import { ActivatedRoute } from '@angular/router';
import { HomeData } from '../../shared/services/item.resolver';



@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, HomeCarouselComponent, WarrentyServiceAndETCComponent, FooterComponent,
    VideosComponent, ShortsComponent, ProdCardComponent,
    HomeContactUsComponent, HomeCarousel2Component, BrandsWeDoComponent, ProductGridComponent, ProductGrid1Component],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './home.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  @Input()
  isSS = false

  carouselShow = false;
  cats: Category[] = [];
  // latestAdditions = new Set<Item>()
  // deals = new Set<Item>()
  i = 0

  dealsArr: Item[] = []
  newArrivalsArr: Item[] = []

  GET_ALL_ITEMS = makeStateKey<any>('GET_ALL_ITEMS');

  DEALS = makeStateKey<any>('DEALS');
  NEW = makeStateKey<any>('NEW');
  HOME_DATA = makeStateKey<any>('HOME_DATA');


  votenow = 0;
  allItems: Item[] = [];
  unlockElements: boolean = false;
  private destroy$ = new Subject<void>();


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private titleService: Title,
    private http: HttpClient,
    private msgService: AppMessageService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private prerenderDataService: PrerenderDataService,
    private itemService: ItemService,
    private route: ActivatedRoute) {
    this.createMetaTag()
    const date = new Date();
    this.votenow = Number(date.getDate());

    msgService.notificationAnnounced$.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e.topic === 'scrolled') {
        this.unlockElements = true
      }
      if (e.topic === 'SCROLL_TO_TOP') {

      }

    })

  }
  ngOnInit() {
    // 1. Synchronously populate from route snapshot data (resolved by homeDataResolver on SSR & CSR)
    const resolvedData = this.route.snapshot.data['homeData'] as HomeData;
    if (resolvedData && resolvedData.deals && resolvedData.newArrivals && (resolvedData.deals.length > 0 || resolvedData.newArrivals.length > 0)) {
      this.dealsArr = [...resolvedData.deals];
      this.newArrivalsArr = [...resolvedData.newArrivals];
    }

    // 2. TransferState fallback check if snapshot data was not populated
    if (this.dealsArr.length === 0 && this.newArrivalsArr.length === 0) {
      const cachedHomeData = this.prerenderDataService.getPreloadedData(this.HOME_DATA);
      if (cachedHomeData?.deals?.length > 0 && cachedHomeData?.newArrivals?.length > 0) {
        this.dealsArr = [...cachedHomeData.deals];
        this.newArrivalsArr = [...cachedHomeData.newArrivals];
      } else {
        const cachedDeals = this.prerenderDataService.getPreloadedData(this.DEALS);
        const cachedNew = this.prerenderDataService.getPreloadedData(this.NEW);
        if (cachedDeals !== null && cachedNew !== null && Array.isArray(cachedDeals) && Array.isArray(cachedNew) && (cachedDeals.length > 0 || cachedNew.length > 0)) {
          this.dealsArr = [...cachedDeals];
          this.newArrivalsArr = [...cachedNew];
        }
      }
    }

    // 3. Keep subscribed to route data for client-side navigation
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(data => {
      const homeData = data?.['homeData'] as HomeData;
      if (homeData && homeData.deals && homeData.newArrivals && (homeData.deals.length > 0 || homeData.newArrivals.length > 0)) {
        this.dealsArr = [...homeData.deals];
        this.newArrivalsArr = [...homeData.newArrivals];
        this._changeDetectorRef.markForCheck();
      }
    });

    // 4. Fallback if both resolver and cache were empty
    if (this.dealsArr.length === 0 && this.newArrivalsArr.length === 0) {
      this.loadFromService();
    }
  }


  ngAfterViewInit(): void {
 
  }



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @HostListener('window:keyup', ['$event'])
  scrollFunc($event: any) {
    this.unlockElements = true;
  }

  @HostListener('window:keydown', ['$event'])
  scrollFunc2($event: any) {
    this.unlockElements = true;
  }
  @HostListener('focus', ['$event'])
  scrollFunc3($event: any) {
    this.unlockElements = true;
  }


  @HostListener('scroll', ['$event'])
  scrollFunc4($event: any) {
    this.unlockElements = true;
  }

  @HostListener('hover', ['$event'])
  scrollFunc5($event: any) {
    this.unlockElements = true;
  }
  @HostListener('mouseover')
  onMouseOver() {
    this.unlockElements = true;
  }

  @HostListener('mouseout')
  onMouseOut() {
    this.unlockElements = true;
  }
  ngAfterContentInit(): void {

  }



  loadFromService() {
    this.itemService.getHomeDealsAndNewArrivals()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          if (data && data.deals && data.newArrivals) {
            this.dealsArr = [...data.deals];
            this.newArrivalsArr = [...data.newArrivals];

            // Store in TransferState for subsequent navigations
            this.prerenderDataService.setPreloadedData(this.DEALS, this.dealsArr);
            this.prerenderDataService.setPreloadedData(this.NEW, this.newArrivalsArr);
            this.prerenderDataService.setPreloadedData(this.HOME_DATA, data);

            this._changeDetectorRef.detectChanges();
          }
        },
        error: (err) => {
          console.error('[Home] Failed to load deals and new arrivals:', err);
        }
      });
  }


  createMetaTag() {
    const title = 'Computer Store in Negombo | Laptops & Gaming PCs | Softnet'
    const des = 'Shop laptops, gaming PCs, desktops, computer parts and accessories at Softnet Computers, Negombo. Islandwide delivery, warranty and expert support. Call Now: 077 (255) 3478'

    this.titleService.setTitle(title)
    this.meta.addTag({ name: 'title', content: title });
    this.meta.addTag({
      name: 'description', content: des
    });
    this.meta.addTag({ name: 'keywords', content: 'Softnet Computers, Negombo, Sri Lanka, computer store, gaming PC, laptops, desktops, computer parts, accessories, gaming laptops, business PCs, used desktops, computer shop Negombo, gaming computer Sri Lanka, branded laptops Sri Lanka, PC parts Sri Lanka' });
    

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk' });
    this.meta.addTag({ property: 'og:url', content: 'https://www.softnetcomputers.lk' });
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ name: 'og:image:width', content: '1200' });
    this.meta.addTag({ name: 'og:image:height', content: '627' });
    this.meta.addTag({ name: 'og:image:alt', content: des });

    this.meta.addTag({ name: 'og:image', content: "http://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'og:image:secure', content: "https://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'og:image:secure_url', content: "https://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });

    this.meta.addTag({ name: 'og:image', content: "http://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'og:image:secure', content: "https://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'og:image:secure_url', content: "https://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });


    this.meta.addTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk' });
    this.meta.addTag({ property: 'twitter:url', content: 'https://www.softnetcomputers.lk' });
    this.meta.addTag({ property: 'twitter:title', content: title });
    this.meta.addTag({ name: 'twitter:description', content: des });


    this.meta.addTag({ name: 'twitter:image', content: "http://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'twitter:image:secure', content: "https://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'twitter:image:secure_url', content: "https://softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });

    this.meta.addTag({ name: 'twitter:image', content: "http://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'twitter:image:secure', content: "https://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });
    this.meta.addTag({ name: 'twitter:image:secure_url', content: "https://www.softnetcomputers.lk/assets/branding/softnetcomputers.lk.png" });




  }

  pickRandom(arr: any, count: number) {
    if (!arr || arr.length === 0) return [];
    if (arr.length <= count) return [...arr];
    const picked: any[] = [];
    const indexes: number[] = []
    for (let i = 0; i < count; i++) {
      let randomIndex = Math.floor(Math.random() * arr.length);
      while (indexes.includes(randomIndex)) {
        randomIndex = Math.floor(Math.random() * arr.length);
      }
      indexes.push(randomIndex);
      picked.push(arr[randomIndex]);
    }
    return picked;
  }

}
